export default __webpack_public_path__ + "static/media/Digital Keys.d1758cad.svg";